var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassportIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2577",
    "data-name": "Group 2577",
    transform: "translate(-370 -470)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(370 470)",
    fill: "#3381f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M91.4,25.977a8.476,8.476,0,1,1,8.476,8.476A8.485,8.485,0,0,1,91.4,25.977Zm27.153-13.025V46.8a1.753,1.753,0,0,1-1.751,1.751H82.949A1.753,1.753,0,0,1,81.2,46.8V12.952A1.753,1.753,0,0,1,82.949,11.2H116.8a1.753,1.753,0,0,1,1.751,1.751Zm-1.946.195H83.144v29.3a10.775,10.775,0,0,1,9.549-5.8h14.364a10.775,10.775,0,0,1,9.549,5.8Z",
    transform: "translate(305.938 475.935)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportIcon);
export default __webpack_public_path__ + "static/media/passport-icon.e351dd65df49716356a77a9d3d044d81.svg";
export { ForwardRef as ReactComponent };